export default __webpack_public_path__ + "static/sofa-184551_1280-810241b6b760954b4bbb261aa7661fe0.png";